export const LIST_PARAMS = {
  territories: 'territory',
  applications: 'application',
  indications: 'indication',
  marketingClaims: 'marketingClaim',
  partners: 'partner',
  categories: 'category',
  agreements: 'agreement',
} as const;

export const MODE_PARAMS = {
  applications: 'applicationMode',
  indications: 'indicationMode',
  marketingClaims: 'marketingClaimMode',
} as const;

export const FILTER_PARAM_NAMES: string[] = [
  ...Object.values(LIST_PARAMS),
  ...Object.values(MODE_PARAMS),
  'new',
  'newStudy',
];
